import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteRichTextDocumentArguments {
  params: OpalApiRequestParams<'DeleteRichTextDocumentV3'>
}

// The Rich Text Document Delete endpoint does not return data,
// only a response with a `204` status code. Because
// of that, we will hard code `null` as the response
export async function deleteRichTextDocument({
  params,
}: DeleteRichTextDocumentArguments): Promise<null> {
  const url = new URL(
    `/rich_texts/v3/documents/${params.path.rich_text_document_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
